import cls from 'classnames';
import { Image, Select } from '@bfe/moly';
import { DAppsIcon } from '@bfe/moly-icons';
import { NoSSR } from '@web3/base-components';
import styles from './index.module.less';

interface IProps {
  network: string | any;
  onChange: (param: any) => void;
  options?: any;
  size?: 'small' | 'xs' | 'large' | 'medium' | any;
  mode?: 'multiple' | 'combobox' | 'tags' | any;
}

export const NetworkSelect = ({
  network,
  options,
  size = 'xs',
  mode = 'combobox',
  onChange,
}: IProps) => {
  const valueRender = (
    _: any,
    option: { iconNightUrl: string; label: string; chainCode: string }
  ) => {
    const { iconNightUrl, label, chainCode } = option;
    return (
      <div
        key={label}
        className={cls(
          'flex items-center whitespace-nowrap',
          styles.selectItem
        )}
      >
        {iconNightUrl && (
          <Image
            key={iconNightUrl}
            className={cls(styles.symbolIcon)}
            src={iconNightUrl}
            width={16}
            height={16}
            alt=""
          />
        )}
        {!chainCode && (
          <div className={styles.allIconArea}>
            <DAppsIcon className={styles.allIcon} />
          </div>
        )}
        {label}
      </div>
    );
  };
  const renderNode = (item: {
    iconNightUrl: string;
    label: string;
    chainCode: string;
  }) => {
    const { iconNightUrl, label, chainCode } = item;
    return (
      <div
        key={label}
        className={cls(
          'flex items-center whitespace-nowrap',
          styles.selectItem
        )}
      >
        {iconNightUrl && (
          <Image
            key={iconNightUrl}
            className={cls(styles.symbolIcon)}
            src={iconNightUrl}
            width={16}
            height={16}
            alt=""
          />
        )}
        {!chainCode && (
          <div className={styles.smallAllIconArea}>
            <DAppsIcon className={styles.smallAllIcon} />
          </div>
        )}
        {label}
      </div>
    );
  };

  return (
    <NoSSR>
      <div className={cls('flex items-center', styles.selectGroupBg)}>
        <Select
          width="max-content"
          size={size}
          mode={mode}
          className={styles.filterItem}
          options={options}
          placeholder=" "
          value={network}
          valueRender={valueRender}
          RenderNode={renderNode}
          onChange={onChange}
        />
      </div>
    </NoSSR>
  );
};
